export enum SegmentStatus {
  Accepted = 'ACCEPTED',
  OnHold = 'ON_HOLD',
  Rejected = 'REJECTED',
  Quarantine = 'QUARANTINE',
  Installed = 'INSTALLED',
  Uninstalled = 'UNINSTALLED',
  TunnelRejected = 'TUNNEL_REJECTED',
  Virtual = 'VIRTUAL',
}

export const UpdatableSegmentStatuses = [
  SegmentStatus.Accepted,
  SegmentStatus.OnHold,
  SegmentStatus.Quarantine,
  SegmentStatus.Rejected,
] as const;

export type UpdatableSegmentStatus = (typeof UpdatableSegmentStatuses)[number];
